"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCodeFromError = void 0;
function getCodeFromError(error) {
    // eslint-disable-next-line no-null/no-null
    if (typeof error === 'object' && error !== null) {
        const code = error.code;
        if (typeof code === 'string') {
            return code;
        }
    }
}
exports.getCodeFromError = getCodeFromError;
